import React from 'react';
import {Container, Stack, Loader, Text} from '@mantine/core';

export const LoadingIndicator = () => {
  return (
    <Container size="xl" py={{base: 'xs', sm: 'md'}} px={{base: 'xs', sm: 'md'}}>
      <div style={{minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <Stack align="center" gap="md">
          <Loader size="lg" />
          <Text size="sm" c="dimmed">Loading...</Text>
        </Stack>
      </div>
    </Container>
  );
};